import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import Logo from "./Logo";
import { Button } from "./ui/button";
import { Menu, X, LogOut, LayoutDashboard } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const links = [
    { label: "How it works", href: "/#how" },
    { label: "What we help with", href: "/#help" },
    { label: "Packages", href: "/#packages" },
    { label: "FAQ", href: "/#faq" },
    { label: "Contact", href: "/#contact" },
  ];

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-40 w-full backdrop-blur-md bg-white/85 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16">
        <Link to="/" data-testid="nav-home-link"><Logo className="h-10" /></Link>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="text-sm font-medium text-slate-600 hover:text-emerald-600 transition-colors" data-testid={`nav-link-${l.label.replace(/\s+/g, "-").toLowerCase()}`}>
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <>
              <Button variant="ghost" onClick={() => navigate("/dashboard")} data-testid="nav-dashboard-btn" className="text-[#0A192F]">
                <LayoutDashboard className="w-4 h-4 mr-1" /> Dashboard
              </Button>
              <Button onClick={handleLogout} data-testid="nav-logout-btn" className="bg-[#0A192F] hover:bg-[#12233f] text-white">
                <LogOut className="w-4 h-4 mr-1" /> Logout
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" onClick={() => navigate("/login")} data-testid="nav-login-btn" className="text-[#0A192F]">Log in</Button>
              <Button onClick={() => navigate("/register")} data-testid="nav-register-btn" className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold rounded-full px-6">Become a member</Button>
            </>
          )}
        </div>

        <button className="lg:hidden text-[#0A192F]" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white px-4 py-4 space-y-3">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="block text-slate-700 font-medium py-1">{l.label}</a>
          ))}
          <div className="pt-2 flex flex-col gap-2">
            {user ? (
              <>
                <Button onClick={() => { setOpen(false); navigate("/dashboard"); }} className="bg-[#0A192F] text-white">Dashboard</Button>
                <Button onClick={handleLogout} variant="outline">Logout</Button>
              </>
            ) : (
              <>
                <Button onClick={() => { setOpen(false); navigate("/login"); }} variant="outline">Log in</Button>
                <Button onClick={() => { setOpen(false); navigate("/register"); }} className="bg-emerald-600 text-white">Become a member</Button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
